// i18n area 'vms' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.lv-LV.meta.json.
import type { enUS } from './vms'

export const lvLV: typeof enUS = {
  vms: {
    spof: {
      title: 'Neatkarība no mezgla',
      single: 'Viens atteices punkts',
      alternativesNow: 'Alternatīvas tagad',
      structural: 'Pēc uzbūves',
      binding: 'Saistošais ierobežojums',
      movableNow: 'Migrācija iespējama tagad',
    },
    title: 'Virtuālās mašīnas',
    migratingChip: 'Notiek migrācija',
    templateChip: 'Template',
    expendableTooltip: 'Degradētā klasterī tā ir starp pirmajām, ko aptur, un pēc mezgla zaudēšanas var neatsākties.',
    expendableHaTooltip: 'Vienmēr tiek restartēta, kamēr klasteris ir vesels; degradētā klasterī aizsargātās VM ir pirmās — to var apturēt vai tā var palikt izslēgta, līdz klasteris atkal ir pilns, tad tā atgriežas pati.',
    viewDetails: 'Skatīt detaļas',
    profileLegacy: 'Cita OS',
    hugePagesNone: 'Nav — parasta atmiņa',
    hugePages2M: '2 MiB lapas',
    hugePages1G: '1 GiB lapas',
    searchPlaceholder: 'Meklēt pēc nosaukuma',
    name: 'Nosaukums',

    // VIENA terminoloģija (#94a): fāzi visur sauc par 'Fāze' — vecā atslēga
    // 'state' nomira līdz ar saraksta pulēšanu.
    vcpus: 'vCPU',
    memory: 'Atmiņa',
    ipAddresses: 'IP adreses',
    noIp: 'Nav IP',
    authorityNode: 'Authority',
    authorityNextStart: 'piešķirta nākamajā palaišanā',
    scope: 'Scope',
    empty: 'Nav nevienas virtuālās mašīnas',
    loadError: 'Neizdevās ielādēt virtuālās mašīnas — vai TVirt backend ir sasniedzams?',
    filterOverlay: 'overlay tīkls',
    filterDisk: 'disks',
    filterImage: 'attēls',
    filteredBy: 'Filtrētas pēc: {kind}',
    filterPhase: 'Fāze',
    filterProtection: 'Aizsardzība',
    filterAll: 'Visas',
    filterScopePlaceholder: 'Filtrēt pēc scope',
    filtersToggle: 'Filtri',
    scopeTree: {
      title: 'Scope',
      all: 'Viss klasteris',
      noChildren: 'Šeit nav neviena apakšscope',
      recursive: 'Iekļaut pakārtotos',
      collapse: 'Sakļaut scope paneli',
      up: 'Vienu līmeni augšup',
      countTooltip: '{direct} VM šajā scope · {total} ar pakārtotajiem'
    },

    // Divsoļu ISO izvēlētājs (#85): vispirms katalogs, tad tā ISO.
    isoPicker: {
      catalog: 'Katalogs',
      unknownCatalog: 'Ārpus redzamajiem katalogiem',
      noIsos: 'Šajā katalogā nav neviena gatava ISO attēla'
    },
    actionsHeader: 'Darbības',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Aparatūra',
      tags: 'Tagi',
      age: 'Vecums',
      disk: 'disks',
      disks: 'diski',
      empty: 'Nav neviena template — jāatzīmē kāda izslēgta VM kā template vai jāklonē VM kā template.',
      clone: 'Klonēt / izvietot',
      editTags: 'Rediģēt tagus',

      // Kārta K3 (#64): eksportē template kā kataloga failu .tvtpl.
      exportAction: 'Eksportēt katalogā (.tvtpl)',
      exportTitle: 'Eksportēt katalogā',
      exportSubmit: 'Eksportēt',
      exportError: 'Eksportēšana neizdevās',
      exportHint: 'Template tiek iepakots .tvtpl arhīvā (aparatūras manifests + katrs disks saplacināts qcow2 formātā) kā jauns VM Template fails izvēlētajā katalogā. NIC, CD/DVD datu nesēji un cloud-init līdzi nedodas — formāta specifikācija uzskaita katru apzināto izlaidumu.',
      exportName: 'Faila nosaukums',
      exportNameHint: 'Tukšs = <template>-export-<n>',
      exportStorageDefault: 'Template metadatu storage',

      // Imports no kataloga (Luca 2026-08-03): ieeja Template cilnes rīkjoslā —
      // K3/K4 backend sedz visus vm-template formātus, izvēle ir FAILS
      // (formāts ceļo tikai lasīšanai).
      importAction: 'Importēt no kataloga',
      importTitle: 'Importēt no kataloga',
      importHint: 'Ready VM Template fails izvēlētajā katalogā kļūst par inventāra template: faila formāts (tvtpl, ova, ovf vai kails qcow2) pats nosaka, kā notiek imports — jāizvēlas tikai fails.',
      importFile: 'Kataloga fails',
      importFileHint: 'Importē tikai ready failus — pusceļā augšupielādēts nav importējams',
      importNoFiles: 'Šajā katalogā nav neviena ready VM Template faila — vispirms tāds jāaugšupielādē vai jāeksportē'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy saderība',
      quickDeployNone: 'Nav deklarēta',
      quickDeployHint: 'Deklarējiet to tikai tad, ja golden attēlā ir cloud-init (Linux) vai cloudbase-init pēc sysprep /generalize (Windows): platforma uzticas deklarācijai un nekad neskatās viesī iekšā.',
      notFound: 'Template nav atrasts',
      frozen: 'Aparatūras konfigurācija ir iesaldēta: lai to mainītu, template jāpārvērš atpakaļ par VM. Nosaukums, piezīmes un tagi paliek maināmi.',
      storage: 'Storage',
      size: 'Izmērs',
      configTitle: 'Konfigurācija (iesaldēta)',
      usbClasses: 'Pieprasītās USB klases',
      gpuClasses: 'Pieprasītās GPU klases'
    },
    sharedDisksTab: {
      title: 'Koplietotie diski',
      sharing: 'Koplietošana',
      sharingNone: 'Viens pievienojums',
      sharingMultiwriter: 'Koplietota rakstīšana (multiwriter)',
      sharingReadonly: 'Koplietots tikai lasīšanai',
      usedBy: 'Izmanto',
      attachedTo: 'Pievienots',
      notAttached: 'Nav pievienots nevienai VM',
      changeSharing: 'Mainīt koplietošanas režīmu',
      changeSharingTitle: 'Koplietošanas režīms',
      changeSharingLocked: 'Režīmu var mainīt tikai, kamēr disku neizmanto neviena VM',
      sharingChanged: 'Koplietošanas režīms atjaunināts.',
      lun: 'Viss LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Sērijas numurs',
      antiAffinityWarning: 'Divi vai vairāki dalībnieki darbojas vienā mezglā bez anti-afinitātes kārtulas: viena mezgla atteice nogāzīs visus',
      antiAffinityCreate: 'Izveidot kārtulu',
      createSourceLun: 'Pārņemt visu target LUN',
      createLunNumber: 'LUN numurs (namespace id NVMe)',
      createLunHint: 'Nekas netiek piešķirts: izmērs tiek nolasīts no ierīces pārņemšanas brīdī',
      noPr: 'Šajā laidienā nav SCSI-3 persistent reservations: Windows Failover Cluster ar klasisko koplietoto disku nav validēts; klasteri, kas koordinējas tīklā (GFS2/OCFS2, RHEL HA, shared-disk datubāzes), ir'
    },
    unusedDisksTab: {
      title: 'Neizmantotie diski',
      attach: 'Pievienot VM',
      attachTitle: 'Pievienot VM',
      vm: 'Virtuālā mašīna',
      noVms: 'Nav pieejama neviena VM',
      noSlots: 'Šajā VM nav neviena brīva slota',

      // Patstāvīga diska izveide (#87): atgriezusies no pensionētā Inventāra,
      // tagad ar SKAIDRI norādītu scope lauku (nav VM, no kuras to mantot).
      create: 'Izveidot disku',
      createTitle: 'Izveidot disku',
      createSourceBlank: 'Tukšs disks',
      createSourceImage: 'No kataloga attēla',
      createImage: 'Attēls',
      createImageEmpty: 'Redzamajos katalogos nav gatava VM veidnes attēla',
      createSizeFromImageHint: 'Aizpildīts ar attēla virtuālo izmēru — tas var tikai augt',

      // #107 (DESTRUKTĪVI, ratificēts): qcow2 → kataloga fails vm-template
      // tajā pašā storage, nulle kopētu baitu — disks beidz pastāvēt.
      convert: 'Pārvērst par VM template…',
      convertOnlyQcow2: 'Pārvērš tikai qcow2 diskus — raw nav reģistrējams template formāts',
      convertTitle: 'Pārvērst par VM template',
      convertSubmit: 'Pārvērst (iznīcina disku)',
      convertError: 'Neizdevās sākt pārvēršanu',
      convertWarning: 'DESTRUKTĪVI: disks kļūst par VM template failu izvēlētajā katalogā — tas pats storage, nulle kopētu baitu — un BEIDZ PASTĀVĒT kā disks. Atpakaļceļa nav, izņemot jauna diska izveidi no template.',
      convertNameHint: 'Kataloga faila nosaukums — pēc noklusējuma diska nosaukums',
      convertConfirm: 'Sapratu: disks tiks iznīcināts',
      convertStarted: 'Pārvēršana sākta — template parādās katalogā, kad task noslēdzas.',
      storageLockHint: 'Storage mainās tikai ar darbību Pārvietot',
      source: 'Izcelsme',
      sourceClone: 'Cita diska klons',
      sourceCloneLinked: 'Cita diska linked clone',
      sourceImage: 'Izveidots no attēla',
      sourceBlank: 'Izveidots tukšs',
      allocated: 'Piešķirts / virtuālais izmērs',
      observedAt: 'Novērots',
      snapshots: 'Snapshot',
      snapshotsEmpty: 'Nav neviena snapshot'
    },
    phase: {
      defined: 'Nekad nav ieslēgta',
      starting: 'Notiek palaišana',
      running: 'Darbojas',
      stopping: 'Notiek apturēšana',
      stopped: 'Izslēgta',
      paused: 'Pauzēta',
      failed: 'Kļūdas stāvoklī',
      deleting: 'Notiek dzēšana'
    },
    stopCause: {
      'api': 'Apturēta ar TVirt (darbība vai API)',
      'guest-shutdown': 'Izslēgšanu sāka viesa operētājsistēma',
      'crash': 'Viesa avārija',
      'qemu-exit': 'QEMU process negaidīti beidza darbu',
      'host-reboot': 'Mezgls tika pārstartēts',
      'migrated': 'Migrēta uz citu mezglu',
      'fenced': 'Pārtraukta ar HA fencing (mezgls atgriezās)'
    },
    detail: {
      notFound: 'Virtuālā mašīna nav atrasta',
      details: 'Detaļas',
      id: 'ID',
      scope: 'Scope',
      profile: 'Aparatūras profils',
      firmware: 'Programmaparatūra',
      firmwareFile: 'UEFI programmaparatūras versija',
      firmwareUpdate: 'Pieejams atjauninājums',
      firmwareUpdateHint: 'Platforma piegādā jaunāku UEFI programmaparatūru. Atjaunināšana nekad nenotiek automātiski: to piemēro izslēgtai VM, kad tu tā izlem.',
      arch: 'Arhitektūra',
      node: 'Mezgls',
      bootOrder: 'Sāknēšanas secība',
      agent: 'Aģenta stāvoklis',
      agentConnected: 'Savienots',
      agentNotConnected: 'Nav savienots',
      protected: 'Aizsargāta',
      linkedClones: 'Saistītie kloni',
      restartPolicy: 'Pārstartēšanas politika',
      preferredNode: 'Vēlamais mezgls',
      noPreference: 'Bez priekšrokas (automātisks izvietojums)',
      preferNodes: 'Vēlamie mezglu tagi',
      requireNodes: 'Obligātie mezglu tagi',
      noPlacementTags: 'Nav',
      placementTag: 'Tags',
      placementValue: 'Vērtība',
      placementAddTag: 'Pievienot tagu',
      proximityHa: 'TVirt Proximity HA',
      proximityHaRestarts: 'HA pārstartēšanas',
      proximityHaGaveUp: 'avāriju cilpa — HA padevās',
      failoverProtection: 'Aizsardzība degradētā klasterī',
      protectionProtected: 'Aizsargāta',
      protectionExpendable: 'Upurējama degradācijā',
      protectionInherit: 'Mantot',
      lastStop: 'Pēdējā apturēšana',
      yes: 'Jā',
      no: 'Nē',
      tabOverview: 'Pārskats',
      tabSnapshots: 'Snapshot',
      tabBackups: 'Kopijas',
      hardware: 'Aparatūra',
      name: 'Nosaukums',
      hwSystem: 'Sistēma',
      hwCpu: 'CPU',
      hwMemory: 'Atmiņa',
      hwBoot: 'Sāknēšana',
      hwIdentity: 'Identitāte',
      hwCluster: 'Klasteris un aģents',
      cpuTopology: 'CPU topoloģija',
      cpuModel: 'CPU modelis',
      cpuLimit: 'CPU ierobežojums',
      cpuWeight: 'CPU svars',
      cpuNested: "Ligzdotā virtualizācija",
      cpuNestedHint: "Atklāj viesim vmx/svm (tikai ar CPU modeli host). Darbojošā VM izmaiņa stājas spēkā nākamajā power cycle (PendingRestart); izvietojums pieļauj tikai mezglus ar ieslēgtu nested.",
      unlimited: 'Neierobežots',
      memory: 'Atmiņa',
      balloon: 'Balloon',
      hugePages: 'Milzu lapas',
      hugePagesTradeoff: 'Mazāk adrešu tulkošanas darba un atmiņa, kas nekad nenonāk uz diska; pretī rezervācija paliek piesaistīta mezglam, kamēr VM darbojas, atmiņa vairs netiek deduplicēta, un startēšana neizdodas, ja mezglam ir par maz brīvu lapu.',
      disks: 'Diski',
      cdroms: 'CD/DVD diskdziņi',
      nics: 'Tīkla saskarnes',
      slot: 'Slots',
      disk: 'Disks',
      encrypted: 'Šifrēts',
      image: 'Attēls',
      emptyDrive: 'Tukšs diskdzinis',
      emptyOption: '(tukšs)',
      network: 'Tīkls',
      mac: 'MAC',
      connected: 'Pievienota',
      unplugged: 'Atvienota',
      noDevices: 'Nav',
      screenshot: 'Ekrānuzņēmums',
      capturedAt: 'Uzņemts',
      noCapture: 'Nav neviena uzņēmuma',
      snapshotName: 'Nosaukums',
      snapshotCreated: 'Izveidots',
      snapshotMemory: 'Iekļauta atmiņa',
      noSnapshots: 'Nav neviena snapshot',
      pendingRestart: 'Gaidošas izmaiņas: tās tiks piemērotas nākamajā barošanas ciklā.',
      applied: 'piemērots',
      appliedHint: 'VM darbojas ar šo vērtību — konfigurētā tiks piemērota nākamajā barošanas ciklā.',
      actionError: 'Darbība neizdevās',
      actionStillRunning: 'Darbība vēl turpinās — iznākums vēl nav zināms',
      tabConsole: 'Konsole',
      consoleConnect: 'Savienot',
      consoleDisconnect: 'Atvienot',
      consoleConnecting: 'Notiek savienošana…',
      consoleReconnecting: 'Notiek savienošana…',
      consoleUnavailable: 'Konsole ir pieejama, kad VM darbojas vai ir pauzēta.',
      consoleError: 'Neizdevās izveidot savienojumu ar konsoli',
      consoleTaken: 'Konsoles sesiju pārņēma {user}',
      consoleReconnect: 'Savienot atkārtoti',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Turēt nospiestu {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Atvērt pilnekrānā jaunā cilnē',
      consoleLoadFailed: 'VM nav atrasta vai nepietiek atļauju',
      consoleClose: 'Aizvērt',
      tabStats: 'Statistika',
      tabTasks: 'Task',
      tabLogs: 'Žurnāls',
      statsCpu: 'CPU',
      statsMemory: 'Atmiņa',
      statsDisk: 'Diska I/O',
      statsRange: 'Intervāls',
      statsNoData: 'Šajā intervālā nav datu — statistika tiek ievākta, kamēr VM darbojas.',
      statsError: 'Neizdevās ielādēt statistiku',
      cpuUsage: 'Izmantojums',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Izmantota',
      memGuestAvailable: 'Pieejama (viesim)',
      schema: 'Shēma',
      consoleProtocol: 'Konsole',
      agentEnabled: 'Viesa aģents',
      metadataStorage: 'Metadatu storage',
      startupOnBoot: 'Startēšana sāknējoties',
      startupOrder: 'Startēšanas secība',
      startupDelay: 'Startēšanas aizture',
      seconds: 's',
      enabled: 'Ieslēgts',
      disabled: 'Izslēgts'
    },
    actionsAvailable: 'Pieejamās darbības',
    actions: {
      start: 'Palaist',
      stop: 'Apturēt',
      pause: 'Pauzēt',
      resume: 'Turpināt',
      reset: 'Atiestatīt',
      migrate: 'Migrēt',
      clone: 'Klonēt',
      moveStorage: 'Pārvietot uz storage…',
      moveScope: 'Pārvietot uz scope…',
      openConsole: 'Atvērt konsoli',
      forceStop: 'Piespiedu izslēgšana',
      markTemplate: 'Atzīmēt kā template',
      unmarkTemplate: 'Pārvērst atpakaļ par VM',
      error: 'Neizdevās izpildīt darbību'
    },
    cordon: {
      confirmTitle: 'Mezgls ir apkopē',
      confirmHint:
        'Kordonu nevar nolaist, kamēr klastera store nav pieejams. Apstiprinot jūs paziņojat, ka to zināt: VM tur tik un tā ieslēdzas, un piekrišana paliek reģistrēta uzdevumā.',
      confirm: 'Ieslēgt tik un tā'
    },
    markTemplate: {
      confirmTitle: 'Vai atzīmēt {name} kā template?',
      confirmBody: 'Konfigurācija iesalst, un VM vairs nevarēs ieslēgties — tikai klonēties vai kļūt atpakaļ par VM. Nosaukums, piezīmes un tagi paliek maināmi.',
      confirm: 'Atzīmēt kā template',
      moved: '{name} tagad ir template — tā pārcēlusies uz cilni Template.'
    },
    unmarkTemplate: {
      confirmTitle: 'Vai pārvērst {name} atpakaļ par VM?',
      confirmBody: 'Template kļūst par parastu VM: maināmu un palaižamu (nākamā palaišana to novieto uz kāda mezgla).',
      confirm: 'Pārvērst atpakaļ par VM',
      moved: '{name} atkal ir virtuālā mašīna — tā pārcēlusies uz cilni Virtuālās mašīnas.'
    },

    // Kārta #123: atsauce uz mezglu pēc TAGA (selektors #106) palaišanas un
    // migrācijas dialogos — ieskaitot atrisinātās kopas priekšskatījumu.
    nodeByTag: {
      label: 'Pēc mezgla taga',
      hint: 'tags=vērtība, atdalīti ar komatu (saistīti ar UN): lēmējs izvēlas starp atbilstošajiem mezgliem',
      invalid: 'Nederīgs formāts — jālieto tags=vērtība, atdalīti ar komatu',
      resolved: 'Atbilstošie dalībnieki: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migrēt',
      target: 'Mērķa mezgls',
      auto: 'Automātiski (Proximity)',
      hint: 'VM pārceļas bez barošanas cikla. Katram storage, ko tā aizskar, jābūt koplietotam; pauzēta VM migrē pauzēta.',
      error: 'Migrācija tika noraidīta'
    },
    moveStorage: {
      title: 'Pārvietot uz storage',
      submit: 'Pārvietot',
      target: 'Mērķa storage',
      noTargets: 'Neviens storage nepieņem diskus',
      hint: 'Visi izslēgtās VM diski pa vienam pārceļas uz izvēlēto storage, saglabājot savu id — tie, kas jau ir mērķī, tiek izlaisti. Progress mīt task lapā.',
      error: 'Pārvietošana tika noraidīta'
    },
    moveScope: {
      title: 'Pārvietot uz scope',
      submit: 'Pārvietot',
      target: 'Mērķa scope',
      hint: 'VM maina scope nekavējoties — id un diski paliek, tai piederošie diski seko līdzi, un tā var palikt ieslēgta. Šobrīd tā mīt {scope}. Kas to redz, mainās līdz ar scope.',
      error: 'Scope maiņa tika noraidīta'
    },
    start: {
      title: 'Palaist VM',
      submit: 'Palaist',
      target: 'Mērķa mezgls',
      auto: 'Automātiski (ieteicams)',
      recommended: 'ieteicams',
      hint: 'Jāizvēlas mērķa mezgls vai jāļauj Proximity izlemt starp derīgajiem kandidātiem. Mezgli, kas to nevar izmitināt, ir atspējoti kopā ar iemeslu.',
      error: 'Neizdevās palaist VM'
    },
    console: {
      media: 'CD/DVD diskdziņi',
      mediaGuestToolsHint: 'Satur TVirt Guest Tools — no šejienes tās var izstumt vai noņemt diskdzini',
      slotOpsDeferred: 'Šajā profilā diskdziņu pievienošana un noņemšana tiek piemērota nākamajā barošanas ciklā (datu nesēju maiņa notiek uzreiz).',
      mountGuestTools: 'Montēt TVirt Guest Tools',
      ejectGuestTools: 'Izstumt TVirt Guest Tools',
      bootOrder: 'Sāknēšanas secība',
      bootOrderHint: 'Jaunā secība saglabājas uzreiz un tiek piemērota nākamajā barošanas ciklā — konsoles sesija paliek savienota.'
    },
    snapshots: {
      create: 'Izveidot snapshot',
      createTitle: 'Izveidot snapshot',
      createSubmit: 'Izveidot',
      name: 'Nosaukums',
      nameHint: 'Burti, cipari, punkts, defise, pasvītrojums.',
      consistencyHint: 'Konsistence ir automātiska: guest agent iesaldē failu sistēmas, kad tas atbild; citādi VM uz mirkli tiek pauzēta ap snapshot.',
      memory: 'Iekļaut atmiņu',
      memoryHint: 'Notver dzīvo RAM: atjaunošana atsāk VM darbībā. Nepieciešami visi diski qcow2 formātā.',
      currentChip: 'Jūs esat šeit',
      revert: 'Atjaunot',
      revertTitle: 'Vai atjaunot {name}?',
      revertBody: 'Diski atgriežas snapshot stāvoklī; viss, kas notika pēc tam, tiek zaudēts. Snapshot tikai ar diskiem prasa apturētu VM.',
      delete: 'Dzēst',
      deleteTitle: 'Vai dzēst snapshot {name}?',
      deleteBody: 'Atjaunošanas punkts pazūd; disku saturs paliek neskarts.',
      deleteMergeHint: 'Tā delta saplūst ar {children}: katrs vēlākais atjaunošanas punkts paliek derīgs.',
      deleteDuplication: 'Piekrītu dublēšanai',
      deleteDuplicationHint: 'Delta tiek nokopēta katrā no {count} lasītājiem (bērnu snapshot un, ja šis ir pašreizējais, aktīvajā galvā): aizņemtā vieta var pieaugt, nevis sarukt.',
      error: 'Darbība ar snapshot tika noraidīta'
    },
    clone: {
      title: 'Klonēt VM',
      submit: 'Klonēt',
      name: 'Kopijas nosaukums',
      storage: 'Disku mērķa storage',
      sameStorage: 'Tas pats, kas avotam',
      full: 'Pilna kopija',
      fullHint: 'Kopē katru baitu un pārrauj saikni ar avota diskiem. Noklusējums ir linked clone: momentāns, bet piesaistīts avotam (tikai qcow2).',
      hint: 'Klons saglabā avota konfigurāciju un programmaparatūru; MAC adreses un TPM identitāte ir jaunas.',
      markAs: 'Klona tips',
      markAsInheritVm: 'Tāds pats kā avots (VM)',
      markAsInheritTemplate: 'Tāds pats kā avots (template)',
      markAsVm: 'Virtuālā mašīna',
      markAsTemplate: 'Template',
      markAsHintVm: 'Jāizvēlas Template, lai kopiju paaugstinātu vienā solī.',
      markAsHintTemplate: 'Jāizvēlas Virtuālā mašīna, lai vienā solī izvietotu no šī template.',
      error: 'Klonēšana tika noraidīta'
    },
    bulk: {
      selected: 'atlasītas',
      deleteTitle: {
        zero: 'Vai dzēst {count} atlasīto VM?',
        one: 'Vai dzēst {count} atlasīto VM?',
        other: 'Vai dzēst {count} atlasītās VM?'
      },
      deleteBody: 'Katra VM iziet tās pašas pārbaudes, kas atsevišķā dzēšanā; atteikumi tiek uzrādīti katram elementam.',
      done: 'pieņemtas',
      refused: 'atteiktas'
    },
    delete: {
      button: 'Dzēst',
      confirmTitle: 'Vai dzēst {name}?',
      confirmBody: 'Virtuālā mašīna un tai piederošie diski tiks dzēsti. Darbība nav atgriezeniska.',
      keepDisks: 'Paturēt diskus',
      keepDisksHint: 'Kopā ar VM izveidotie diski paliek savā storage kā patstāvīgi diski.',
      confirm: 'Dzēst',
      cancel: 'Atcelt',
      error: 'Dzēšana neizdevās',
      blockedPhase: 'Vispirms jāaptur VM',
      blockedProtected: 'VM ir aizsargāta — vispirms jānoņem aizsardzība',
      blockedDeleting: 'Dzēšana jau notiek'
    },
    logs: {
      title: 'Žurnāls',
      subtitle: 'Strukturēti žurnāla ieraksti no task, kas skar šo VM',
      when: 'Kad',
      task: 'Task',
      level: 'Līmenis',
      message: 'Ziņojums',
      empty: 'Vēl nav neviena žurnāla ieraksta',
      loadError: 'Neizdevās ielādēt žurnālu — vai TVirt backend ir sasniedzams?'
    },
    stop: {
      title: 'Apturēt virtuālo mašīnu',
      modeGraceful: 'Saudzīga izslēgšana',
      modeGracefulHint: 'Viesa operētājsistēmai tiek lūgts izslēgties dabiskā ceļā (ACPI); ja tā lūgumu ignorē, pēc noildzes seko piespiedu izslēgšana.',
      modeForced: 'Piespiedu izslēgšana',
      modeForcedHint: 'Nekavējoties atslēdz strāvu — tāpat kā izraujot kontaktdakšu.',
      timeout: 'Rezerves noildze (sekundes)',
      timeoutHint: 'Viesim atvēlētais gaidīšanas laiks pirms piespiedu izslēgšanas'
    },

    // Izveides dalītās pogas izvēlne (Luca 2026-07-23): "No nulles" atver
    // vedni, pārējie divi ieraksti ir attīstības plāna aizvietotāji.
    createFromScratch: 'No nulles',
    createFromTemplate: 'No template',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Izpildīt deploy',
      error: 'Deploy neizdevās',
      compatNote: 'QuickDeploy prasa ar QuickDeploy saderīgu veidni: platforma pirmajā palaišanā pielāgo viesi (tīkls, domēns, aktivizācija).',
      template: 'Veidne',
      noTemplates: 'Neviena veidne vēl nedeklarē QuickDeploy saderību — deklarējiet to cilnē Veidnes (Linux ar cloud-init, Windows ar cloudbase-init pēc sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Resursdatora nosaukums',
      hostnameHint: 'Resursdatora nosaukums vai FQDN; tukšs = VM nosaukums (Windows: ne vairāk kā 15 rakstzīmes)',
      ip: 'IP adrese',
      ipHint: 'Adrese un prefikss, piem., 192.168.122.101/24; tukšs = DHCP',
      gateway: 'Vārteja',
      dns: 'DNS serveri',
      dnsHint: 'Līdz trim, atdalīti ar komatu',
      count: 'Instances',
      countHint: 'Vairāk nekā viena: nosauktas <nosaukums>-1…-N, tikai DHCP',
      user: 'Lietotājs',
      userHint: 'Tukšs = attēla noklusējuma lietotājs (Linux) vai Administrator (Windows)',
      password: 'Parole',
      passwordHint: 'Tiek ierakstīta ģenerētajā user-data, ko platforma pēc tam deklarē kā slepenu: neviens to vairs nelasa',
      sshKeys: 'SSH publiskās atslēgas',
      sshKeysHint: 'Viena rindā (ssh-ed25519 AAAA… komentārs)',
      productKey: 'Windows produkta atslēga',
      kmsServer: 'KMS serveris',
      kmsHint: 'Adrese vai adrese:ports — nepieciešama produkta atslēga (KMS klienta atslēga)',
      adDomain: 'Pievienoties Active Directory domēnam',
      adDomainHint: 'Tukšs = bez pievienošanās domēnam',
      adUser: 'Pievienošanās konts',
      adPassword: 'Pievienošanās konta parole',
      adOu: 'Mērķa OU (neobligāti)',
      advanced: 'Papildu: neapstrādāti dokumenti',
      userData: 'user-data (neapstrādāta)',
      userDataHint: 'Aizstāj ģenerēto user-data: lietotājam, parolei, atslēgām un Windows laukiem augstāk jāpaliek tukšiem',
      networkConfig: 'network-config (neapstrādāta)',
      networkConfigHint: 'Aizstāj ģenerēto tīklu: IP, vārtejai un DNS augstāk jāpaliek tukšiem',
      secret: 'Uzskatīt neapstrādāto user-data par slepenu',
      secretHint: 'Atzīmēta kā slepena, API to vairs nevienam neatgriež, un Checkpoint tā ceļo aizzīmogota ar masterpass',
      startNow: 'Palaist uzreiz',
      startNowHint: 'Katra instance tiek palaista, tiklīdz tā ir definēta; seed rodas šajā palaišanā'
    },

    create: {
      nicAttachmentNetwork: 'Loģiskais tīkls (fabric)',
      nicNetwork: 'Loģiskais tīkls',
      nicNetworkHint: 'IETEICAMAIS ceļš (F3): vNIC realizējas uz apkalpojošā mezgla ATVASINĀTĀ tilta — tilts dzimst pie eksplicīta fabric apply, un palaišana uz mezgla, kas to vēl nenes, atsaka runājot. Kad aiziet pēdējā flotes atsauce, tilts izkrīt pie nākamā apply.',
      button: 'Izveidot VM',
      title: 'Izveidot virtuālo mašīnu',
      dialogTitle: 'Izveidot virtuālo mašīnu',
      stepGeneral: 'Vispārīgi',
      stepGeneralHint: 'Nosaukums un profils',
      stepCompute: 'CPU un RAM',
      stepComputeHint: 'Topoloģija un izmēri',
      stepDisks: 'Diski',
      stepDisksHint: 'Izveidot vai pievienot',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Diskdziņi un datu nesēji',
      stepNetwork: 'Tīkls',
      stepNetworkHint: 'NIC: trunk vai bridge',
      stepSummary: 'Kopsavilkums',
      stepSummaryHint: 'Pārbaudīt un izveidot',
      name: 'Nosaukums',
      nameHint: 'Mazie burti, cipari un defises (DNS-1123)',
      nextButton: 'Tālāk',
      prevButton: 'Atpakaļ',
      submitButton: 'Izveidot',
      creating: 'Notiek izveide…',
      sockets: 'Soketi',
      cores: 'Kodoli uz soketu',
      threads: 'Pavedieni uz kodolu',
      totalVcpus: 'vCPU kopā',
      memoryGib: 'Atmiņa (GiB)',
      cpuModelHint: "'host' atklāj hosta CPU",
      cpuLimitHint: 'Griesti hosta kodolos — tukšs = neierobežots',
      cpuNestedHint: "Atklāj viesim vmx/svm, lai tas varētu darbināt savu hipervizoru — nepieciešams CPU modelis host un mezgls ar ieslēgtu nested",
      newDisk: 'Jauns disks',
      attachDisk: 'Pievienot esošu disku',
      diskStorage: 'Storage',
      diskSize: 'Izmērs (GiB)',
      diskSelect: 'Disks',
      addDisk: 'Pievienot disku',
      addCdrom: 'Pievienot CD/DVD diskdzini',
      addNic: 'Pievienot tīkla saskarni',
      remove: 'Noņemt',
      slotLimit: 'Sasniegts slotu ierobežojums',
      cdromImage: 'Attēls (ja nav — tukšs diskdzinis)',
      nicAttachment: 'Pieslēgums',
      nicAttachmentTrunk: 'Overlay trunk',
      nicAttachmentBridge: 'Hosta bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Nav (tikai tagged)',
      nicTrunkHint: 'Vismaz viena puse: viens untagged overlay un/vai tagged VLAN kartējumi — VM var darboties tikai uz tiem hostiem, kurus deklarē katrs norādītais overlay',
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Overlay tīkls',
      addTagged: 'Pievienot tagged VLAN',
      nicBridge: 'Hosta bridge nosaukums',
      nicBridgeHint: 'NM bridge pēc nosaukuma — VM var darboties tikai uz tiem serveriem, kuru hosta tīkls deklarē šo bridge',
      nicMac: 'MAC (automātiski, ja tukšs)',
      noDisksHint: 'Neviena diska: VM būs tikai tie CD/DVD diskdziņi, kurus pievienosiet.',
      noCdromsHint: 'Neviena CD/DVD diskdziņa: jāpievieno viens, lai sāknētu no ISO attēla.',
      mountGuestTools: 'Montēt TVirt Guest Tools pirmajā palaišanā',
      mountGuestToolsHint: 'Ievieto ISO ar virtio draiveriem un guest agent tukšā CD diskdzinī (pievienotā, ja vajag) — Windows instalatoram tas ir vajadzīgs, lai redzētu diskus.',
      noNicsHint: 'Nevienas tīkla saskarnes: VM startēs bez savienojamības.',
      taggedMappings: 'Tagged VLAN kartējumi',
      summaryDevices: 'Ierīces',
      bootOrderTitle: 'Sāknēšanas secība',
      bootOrderHint: 'Jāvelk, lai pārkārtotu — uzvar pirmā sāknējamā ierīce; NIC sāknē ar PXE',
      bootOrderUp: 'Pārvietot augšup',
      bootOrderDown: 'Pārvietot lejup',
      createError: 'Izveide neizdevās'
    },
    edit: {
      button: 'Rediģēt',
      title: 'Rediģēt virtuālo mašīnu',
      cancel: 'Atcelt',
      save: 'Saglabāt',
      error: 'Rediģēšana neizdevās',
      modelStoppedOnly: 'Maināms tikai izslēgtai VM',
      firmwareStoppedOnly: 'Programmaparatūra maināma tikai izslēgtai VM — nākamajā palaišanā mašīna startē ar jauno programmaparatūru, un UEFI mainīgie paliek',
      hugePagesStoppedOnly: 'Maināms tikai izslēgtai VM — nākamajā palaišanā atmiņa piedzimst uz jaunā pamata',
      runningHint: 'Izmaiņas tiek piemērotas nākamajā barošanas ciklā',
      sectionCpu: 'CPU',
      sectionMemory: 'Atmiņa',
      sectionPolicy: 'Kritēriji'
    },
    devices: {
      networkChip: 'fabric tīkls',
      title: 'Ierīces',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Pievienot USB ierīci',
      addUsbTitle: 'Pieprasīt USB ierīču klasi',
      usbClassHint:
        'VM pieprasa USB ierīču KLASI (usb-device taga vērtību), nekad konkrētu ierīci: palaišanas brīdī mezglā tiek izvēlēta un rezervēta konkrēta brīva ierīce. Reģistrētās ierīces jātagē sadaļā Klasteris › USB un PCIe resursi.',
      usbTag: 'Tags (usb-device)',
      usbValue: 'Klases vērtība',
      noUsbTags: 'Nav neviena usb-device taga — jāizveido tāds un jātagē reģistrētās ierīces sadaļā Klasteris › USB un PCIe resursi.',
      noUsbValues: 'Šim tagam vēl nav deklarētu vērtību.',
      usbEmpty: 'Nav nevienas USB prasības — jāpievieno klase, lai palaišanas brīdī nodotu ierīci.',
      usbClassChip: 'klase',
      usbPortChip: 'ports',
      usbUnclaimed: 'Nav rezervēta neviena ierīce — tas atrisinās VM palaišanas brīdī.',
      addGpu: 'Pievienot GPU',
      addGpuTitle: 'Pieprasīt GPU klasi',
      gpuClassHint:
        'VM pieprasa GPU KLASI (gpu-device taga vērtību), nekad konkrētu karti: palaišanas brīdī mezglā tiek izvēlēta un rezervēta konkrēta brīva karte, un KOPĀ tiek nodota visa tās IOMMU grupa. Reģistrētās GPU jātagē sadaļā Klasteris › USB un PCIe resursi.',
      gpuTag: 'Tags (gpu-device)',
      gpuValue: 'Klases vērtība',
      noGpuTags: 'Nav neviena gpu-device taga — jāizveido tāds un jātagē reģistrētās GPU sadaļā Klasteris › USB un PCIe resursi.',
      noGpuValues: 'Šim tagam vēl nav deklarētu vērtību.',
      gpuEmpty: 'Nav nevienas GPU prasības — jāpievieno klase, lai palaišanas brīdī nodotu karti.',
      gpuClassChip: 'klase',
      gpuGroupChip: 'IOMMU grupa ×',
      gpuUnclaimed: 'Nav rezervēta neviena karte — tas atrisinās VM palaišanas brīdī.',
      gpuPowerCycle: 'Nekāda GPU hotplug — izmaiņas stājas spēkā no nākamā barošanas cikla (PendingRestart)',
      actions: 'Darbības',
      attachDisk: 'Pievienot disku',
      attachDiskTitle: 'Pievienot disku',
      attach: 'Pievienot',
      noFreeDisks: 'Nav neviena neizmantota diska — jāizveido tāds sadaļā Virtuālās mašīnas › Neizmantotie diski.',
      addCdrom: 'Pievienot diskdzini',
      addCdromTitle: 'Pievienot CD/DVD diskdzini',
      editCdromTitle: 'Mainīt CD/DVD attēlu',
      changeMedia: 'Mainīt CD/DVD attēlu',
      ejectMedium: 'Izstumt',
      mountGuestTools: 'Montēt TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools ir montētas',
      guestToolsClickMount: 'Ievieto TVirt Guest Tools ISO pirmajā tukšajā CD/DVD diskdzinī',
      guestToolsClickUnmount: 'Jāklikšķina, lai izstumtu — diskdzinis paliek, tukšs',
      guestToolsNoSlot: 'Nav neviena tukša CD/DVD diskdziņa — jāpievieno diskdzinis (vai jāizstumj kāds datu nesējs), lai montētu TVirt Guest Tools',
      guestToolsSkew: 'Piemontēts v{pinned}; mezgls {node} tagad nodrošina v{current}: izņemiet un piemontējiet vēlreiz, lai atjauninātu',
      ejectGuestTools: 'Izstumt TVirt Guest Tools (diskdzinis paliek, tukšs)',
      guestToolsEjectConfirmTitle: 'Vai izstumt TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Datu nesējs tiek izstumts no ieslēgtas VM — CD/DVD diskdzinis paliek, tukšs.',
      applyLive: 'Piemērot uzreiz (VM ir ieslēgta)',
      addNic: 'Pievienot saskarni',
      addNicTitle: 'Pievienot tīkla saskarni',
      editNicTitle: 'Rediģēt tīkla saskarni',
      bridgeChip: 'bridge',
      cable: 'Virtuālais kabelis',
      plug: 'Pievienot virtuālo kabeli',
      unplug: 'Atvienot virtuālo kabeli',
      remove: 'Noņemt',
      removeTitle: 'Vai noņemt {device}?',
      removeBody: 'Ieslēgtai VM izmaiņa tiek piemērota nākamajā barošanas ciklā. Diski un attēli tiek atvienoti, nekad nedzēsti.'
    }
  }
}
